import { render } from "./Column202306.vue?vue&type=template&id=01ab7318&scoped=true"
import script from "./Column202306.vue?vue&type=script&lang=js"
export * from "./Column202306.vue?vue&type=script&lang=js"

import "./Column202306.vue?vue&type=style&index=0&id=01ab7318&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-01ab7318"

export default script